import stickybits from 'stickybits';
import { Component } from '../../helpers/compiler';

@Component({className: 'js-sticky'})
export class StickyComponent {
	constructor(private element: HTMLElement) {
		const offset = parseInt(this.element.getAttribute('data-sticky-offset') || '0');

		stickybits(this.element, {
			parentClass: 'js-sticky-parent',
			stickyChangeClass: 'is-sticky-change',
			stickyClass: 'is-sticky',
			stuckClass: 'is-stuck',
			stickyBitStickyOffset: offset,
			useStickyClasses: true,
		});
	}
}
